type ProductPaging = {
  productsPage?: number;
  productsLimit?: number;
  categoryId?: string;
  priorityCategoryId?: string;
};

export const withProductPaging = <T extends object>(
  params: T,
  paging: ProductPaging
): T => ({ ...params, ...paging } as T);

export const MAX_PRODUCTS_PER_CATEGORY_REQUEST = 500;

export const getCategoryPagesCount = (
  totalCategories: number,
  itemsPerPage: number
): number => (itemsPerPage > 0 ? Math.ceil(totalCategories / itemsPerPage) : 0);

export const hasMoreCategoryPages = (pagination: {
  page: number;
  limit: number;
  total: number;
}): boolean =>
  pagination.page < getCategoryPagesCount(pagination.total, pagination.limit);

export const withLoadedPage = (pages: number[], page: number): number[] =>
  pages.includes(page) ? pages : [...pages, page].sort((a, b) => a - b);

export const lastLoadedPage = (pages: number[]): number =>
  pages.length ? pages[pages.length - 1] : 0;

export const runStartPage = (pages: number[], page: number): number => {
  let start = page;

  while (start > 1 && pages.includes(start - 1)) {
    start -= 1;
  }

  return start;
};
